<div class="form-group">
    <label class="input-label">{{ 'Default value' | translate }}</label>
    <input type="text"
            *ngIf="fieldOptions.type != 'radio' && fieldOptions.type != 'select'"
           name="fieldOptions.label"
           value="{{fieldOptions.defaultValue}}"
           [(ngModel)]="fieldOptions.defaultValue"
           (ngModelChange)="dataChangedEvent($event)"
           class="form-control">
    <select *ngIf="fieldOptions.type == 'radio'"
        name="fieldOptions.label"
        [(ngModel)]="fieldOptions.defaultValue"
        (ngModelChange)="dataChangedEvent($event)"

        class="form-control">
        <option value=''>None</option>
        <option *ngFor="let option of fieldOptions.values;" [(ngValue)]="option.value">{{option.label}}</option>
    </select>
    <select *ngIf="fieldOptions.type == 'select' && fieldOptions.inputType == 'classification'"
        name="fieldOptions.label"
        [(ngModel)]="fieldOptions.defaultValue"
        (ngModelChange)="dataChangedEvent($event)"

        class="form-control">
        <option value=''>None</option>
        <option *ngFor="let option of classificationFields;" [selected]="fieldOptions?.defaultValue === option.id"
                [(ngValue)]="option.id">{{option.value}}</option>
    </select>
    <select *ngIf="fieldOptions.type == 'select' && fieldOptions.inputType =='select'"
            name="fieldOptions.label"
            [(ngModel)]="fieldOptions.defaultValue"
            (ngModelChange)="dataChangedEvent($event)"

            class="form-control">
        <option value=''>None</option>
        <option *ngFor="let option of fieldOptions.data.values;" [(ngValue)]="option.value">{{option.label}}</option>
    </select>

</div>